/* PVI header — desktop-only mega menu hover (≥1200px, fine pointer) */
(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 1200px) and (hover: hover)');

  function closeAll(except) {
    document.querySelectorAll('header-menu details.mega-menu[open]').forEach(function (d) {
      if (d === except) return;
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    });
  }

  function bindMegaMenu(menu) {
    if (menu.dataset.pviHoverBound) return;
    menu.dataset.pviHoverBound = '1';

    var details = menu.querySelector('details.mega-menu');
    if (!details) return;

    var summary = details.querySelector('summary');
    var panel = details.querySelector('.mega-menu__content');
    if (!summary || !panel) return;

    var closeTimer = null;

    function openMenu() {
      if (!DESKTOP_MQ.matches) return;
      clearTimeout(closeTimer);
      closeAll(details);
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose() {
      if (!DESKTOP_MQ.matches) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 180);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
    }

    [summary, panel].forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        cancelClose();
        openMenu();
      });
      el.addEventListener('mouseleave', scheduleClose);
    });

    summary.addEventListener('click', function (e) {
      if (DESKTOP_MQ.matches) e.preventDefault();
    });
  }

  function init() {
    document.querySelectorAll('header-menu').forEach(bindMegaMenu);
  }

  function onModeChange() {
    if (!DESKTOP_MQ.matches) closeAll(null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (DESKTOP_MQ.addEventListener) {
    DESKTOP_MQ.addEventListener('change', onModeChange);
  } else if (DESKTOP_MQ.addListener) {
    DESKTOP_MQ.addListener(onModeChange);
  }
})();
